import PropTypes from 'prop-types';
import { Modal as ModalMantine } from '@mantine/core';
import styles from './styles.module.css';

const Modal = (props) => {
  const {
    close,
    opened,
    actions,
    leftActions,
    label,
    children,
    size = '80%',
  } = props;

  return (
    <ModalMantine.Root
      opened={opened}
      onClose={close}
      centered
      size={size}
      classNames={{ body: styles.body, title: styles.title, header: styles.header }}
      closeOnClickOutside={false}
    >
      <ModalMantine.Overlay />
      <ModalMantine.Content>
        <ModalMantine.Header>
          <ModalMantine.CloseButton />
        </ModalMantine.Header>
        <ModalMantine.Body>
          <ModalMantine.Title>{label}</ModalMantine.Title>
          {children}
          <div className={styles.actionsWrapper}>
            <div className={styles.actions}>{actions}</div>
            <div className={styles.leftActions}>{leftActions}</div>
          </div>
        </ModalMantine.Body>
      </ModalMantine.Content>
    </ModalMantine.Root>
  );
};

Modal.propTypes = {
  opened: PropTypes.bool,
  close: PropTypes.func,
  label: PropTypes.string,
  actions: PropTypes.node,
  leftActions: PropTypes.node,
  children: PropTypes.node,
  size: PropTypes.string,
};

export default Modal;
